(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tom-event-calendar"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('tom-event-calendar')) {
    customElements.define('tom-event-calendar', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.abort = new AbortController();
        this.zone = this.dataset.timezone || 'America/New_York';
        this.locale = this.dataset.locale || 'en';
        this.labels = JSON.parse(this.querySelector('[data-calendar-labels]').textContent);
        const parts = new Intl.DateTimeFormat('en-CA', {timeZone:this.zone,year:'numeric',month:'2-digit',day:'2-digit'}).formatToParts(new Date());
        this.today = ['year','month','day'].map(key => parts.find(part => part.type === key).value).join('-');
        this.year = Number(this.today.slice(0,4));
        this.month = Number(this.today.slice(5,7))-1;
        this.view = matchMedia('(max-width:599px)').matches ? 'list' : 'month';
        this.category = 'all';
        this.showPast = false;
        this.showAll = false;
        this.events = Array.from(this.querySelector('[data-event-cards]').content.children).filter(card => /^\d{4}-\d{2}-\d{2}$/.test(card.dataset.eventDate)).sort((a,b) => (a.dataset.eventDate+(a.dataset.eventTime || '')).localeCompare(b.dataset.eventDate+(b.dataset.eventTime || '')));
        this.querySelector('.tom-calendar__controls').hidden = false;
        this.querySelector('[data-weekdays]').replaceChildren(...Array.from({length:7},(_,i) => {
          const span = document.createElement('span');
          span.textContent = new Intl.DateTimeFormat(this.locale,{weekday:'short',timeZone:'UTC'}).format(new Date(Date.UTC(2026,9,4+i)));
          return span;
        }));
        this.addEventListener('click',event => {
          const button = event.target.closest('button');
          if (!button) return;
          if (button.dataset.eventIndex !== undefined) {
            const card = this.events[Number(button.dataset.eventIndex)];
            this.selectedDate = card.dataset.eventDate;
            this.selectedEvent = Number(button.dataset.eventIndex);
            this.render();
          } else if (button.dataset.day) {
            this.selectedDate = button.dataset.day;
            this.selectedEvent = null;
            this.render();
          } else if (button.dataset.action) {
            const action = button.dataset.action;
            if (action === 'show_all') this.showAll = !this.showAll;
            if (action === 'month' || action === 'list') this.view = action;
            if (action === 'today') {
              this.year = Number(this.today.slice(0,4));
              this.month = Number(this.today.slice(5,7))-1;
              this.selectedDate = null;
              this.selectedEvent = null;
            }
            if (action === 'next' || action === 'previous') {
              const date = new Date(Date.UTC(this.year,this.month+(action === 'next' ? 1 : -1),1));
              this.year = date.getUTCFullYear();
              this.month = date.getUTCMonth();
              this.selectedDate = null;
              this.selectedEvent = null;
            }
            const draw = () => this.render();
            if (document.startViewTransition && !matchMedia('(prefers-reduced-motion:reduce)').matches) document.startViewTransition(draw);
            else draw();
          }
        },{signal:this.abort.signal});
        this.querySelector('[data-category-filter]').addEventListener('change',event => {
          this.category = event.target.value;
          this.selectedDate = null;
          this.selectedEvent = null;
          this.render();
        },{signal:this.abort.signal});
        this.querySelector('[data-show-past]').addEventListener('change',event => {
          this.showPast = event.target.checked;
          this.render();
        },{signal:this.abort.signal});
        document.addEventListener('shopify:block:select',event => {
          const index = this.events.findIndex(card => card.dataset.eventBlock === event.detail.blockId);
          if (index < 0) return;
          const date = this.events[index].dataset.eventDate;
          this.year = Number(date.slice(0,4));
          this.month = Number(date.slice(5,7))-1;
          this.category = 'all';
          this.querySelector('[data-category-filter]').value = 'all';
          this.view = 'month';
          this.selectedDate = date;
          this.selectedEvent = index;
          this.render();
        },{signal:this.abort.signal});
        this.render();
      }
      disconnectedCallback() {
        if (this.abort) this.abort.abort();
        this.initialized = false;
      }
      dateLabel(date,options) {
        const p = date.split('-').map(Number);
        return new Intl.DateTimeFormat(this.locale,Object.assign({timeZone:'UTC'},options)).format(new Date(Date.UTC(p[0],p[1]-1,p[2],12)));
      }
      isPast(card) {
        if (card.dataset.eventDate < this.today) return true;
        if (card.dataset.eventDate > this.today || !card.dataset.eventTime || card.dataset.eventAllDay === 'true') return false;
        const time = new Intl.DateTimeFormat('en-GB',{timeZone:this.zone,hour:'2-digit',minute:'2-digit',hourCycle:'h23'}).format(new Date());
        return card.dataset.eventTime < time;
      }
      card(index) {
        const source = this.events[index];
        const card = source.cloneNode(true);
        card.querySelector('[data-event-date-label]').textContent = this.dateLabel(source.dataset.eventDate,{weekday:'long',month:'long',day:'numeric',year:'numeric'});
        if (this.isPast(source)) {
          card.querySelector('[data-event-ended]').hidden = false;
          const booking = card.querySelector('[data-event-booking]');
          if (booking) booking.remove();
          const update = card.querySelector('.tom-calendar__details-link');
          if (update) update.remove();
        }
        return card;
      }
      empty(message) {
        const p = document.createElement('p');
        p.className = 'tom-calendar__empty';
        p.textContent = message;
        return p;
      }
      render() {
        const focused = this.contains(document.activeElement) ? document.activeElement : null;
        const focusedDay = focused && focused.dataset.day;
        const focusedEvent = focused && focused.dataset.eventIndex;
        const monthKey = this.year+'-'+String(this.month+1).padStart(2,'0');
        const inMonth = this.events.map((card,index) => ({card,index})).filter(item => item.card.dataset.eventDate.startsWith(monthKey) && (this.category === 'all' || item.card.dataset.eventCategory === this.category));
        this.querySelector('[data-month-label]').textContent = this.dateLabel(monthKey+'-15',{month:'long',year:'numeric'});
        this.querySelector('[data-action="month"]').setAttribute('aria-pressed',String(this.view === 'month'));
        this.querySelector('[data-action="list"]').setAttribute('aria-pressed',String(this.view === 'list'));
        this.querySelector('.tom-calendar__month-view').hidden = this.view !== 'month';
        this.querySelector('.tom-calendar__agenda-view').hidden = this.view !== 'list';
        if (!this.selectedDate || !this.selectedDate.startsWith(monthKey)) {
          const first = inMonth.find(item => !this.isPast(item.card)) || inMonth[0];
          this.selectedDate = first ? first.card.dataset.eventDate : null;
        }
        const firstWeekday = new Date(Date.UTC(this.year,this.month,1)).getUTCDay();
        const days = new Date(Date.UTC(this.year,this.month+1,0)).getUTCDate();
        const cells = Math.ceil((firstWeekday+days)/7)*7;
        const grid = [];
        for (let i=0;i<cells;i++) {
          const cell = document.createElement('div');
          cell.className = 'tom-calendar__day';
          const day = i-firstWeekday+1;
          if (day < 1 || day > days) {
            cell.classList.add('tom-calendar__day--outside');
            cell.setAttribute('aria-hidden','true');
            grid.push(cell);
            continue;
          }
          const date = monthKey+'-'+String(day).padStart(2,'0');
          const items = inMonth.filter(item => item.card.dataset.eventDate === date);
          if (date === this.today) cell.classList.add('tom-calendar__day--today');
          if (date < this.today) cell.classList.add('tom-calendar__day--past');
          if (date === this.selectedDate) cell.classList.add('tom-calendar__day--selected');
          const number = document.createElement('span');
          number.className = 'tom-calendar__day-number';
          number.textContent = String(day);
          if (items.length) {
            const trigger = document.createElement('button');
            trigger.type = 'button';
            trigger.className = 'tom-calendar__day-trigger';
            trigger.dataset.day = date;
            trigger.setAttribute('aria-label',this.dateLabel(date,{weekday:'long',month:'long',day:'numeric'})+': '+items.length+' '+(items.length === 1 ? this.labels.event_singular : this.labels.event_plural));
            trigger.setAttribute('aria-pressed',String(date === this.selectedDate));
            trigger.append(number);
            const dots = document.createElement('span');
            dots.className = 'tom-calendar__dots';
            dots.setAttribute('aria-hidden','true');
            items.forEach(() => {
              const dot = document.createElement('span');
              dot.className = 'tom-calendar__dot';
              dots.append(dot);
            });
            trigger.append(dots);
            cell.append(trigger);
            items.forEach(item => {
              const button = document.createElement('button');
              button.type = 'button';
              button.className = 'tom-calendar__event-chip tom-calendar__event-chip--'+item.card.dataset.eventCategory;
              button.dataset.eventIndex = String(item.index);
              button.setAttribute('aria-label',item.card.dataset.eventTitle+', '+this.dateLabel(date,{month:'long',day:'numeric'})+', '+item.card.dataset.eventTimeLabel);
              const time = document.createElement('span');
              time.className = 'tom-calendar__chip-time';
              time.textContent = item.card.dataset.eventTimeLabel;
              const title = document.createElement('span');
              title.textContent = item.card.dataset.eventTitle;
              button.append(time,title);
              cell.append(button);
            });
          } else cell.append(number);
          grid.push(cell);
        }
        this.querySelector('[data-month-grid]').replaceChildren(...grid);
        let selected = inMonth.filter(item => item.card.dataset.eventDate === this.selectedDate);
        if (this.selectedEvent !== null && this.selectedEvent !== undefined) selected = selected.filter(item => item.index === this.selectedEvent);
        this.querySelector('[data-event-details]').replaceChildren(...(selected.length ? selected.map(item => this.card(item.index)) : [this.empty(inMonth.length ? this.labels.empty_day : this.labels.empty)]));
        const upcoming = inMonth.filter(item => this.showPast || !this.isPast(item.card));
        const displayed = this.showAll ? upcoming : upcoming.slice(0,6);
        this.querySelector('[data-event-agenda]').replaceChildren(...(displayed.length ? displayed.map(item => this.card(item.index)) : [this.empty(inMonth.length ? this.labels.empty_upcoming : this.labels.empty)]));
        const more = this.querySelector('[data-calendar-more]');
        more.hidden = upcoming.length <= 6;
        more.textContent = this.showAll ? this.labels.show_less : this.labels.show_all;
        more.setAttribute('aria-expanded',String(this.showAll));
        this.querySelector('[data-calendar-status]').textContent = this.querySelector('[data-month-label]').textContent+': '+inMonth.length+' '+(inMonth.length === 1 ? this.labels.event_singular : this.labels.event_plural);
        if (this.view === 'month' && (focusedDay || focusedEvent !== undefined && focusedEvent !== null)) {
          const selector = focusedDay ? '[data-day="'+focusedDay+'"]' : '[data-event-index="'+focusedEvent+'"]';
          const replacement = this.querySelector(selector);
          if (replacement) replacement.focus({preventScroll:true});
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
